export const SIGN_IN_WORKFLOW_TYPE_ID = 1;
export const SIGN_OUT_WORKFLOW_TYPE_ID = 2;
export const KIOSK_IN_WORKFLOW_TYPE_ID = 3;
export const KIOSK_OUT_WORKFLOW_TYPE_ID = 4;